import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { translate } from '@shared-libs/helpers';
import { ValidationService } from './validation.service';

/**
 * The message service to show messages the user
 */
@Injectable({
	providedIn: 'root',
})
export class MessageService {
	constructor(
		private readonly toastController: ToastController,
		private readonly validationService: ValidationService
	) {}

	/**
	 * Show a toast style message confirming the action of the user is successfully completed
	 * @param message An optional message to show to the user (default: 'De wijzigingen zijn opgeslagen!')
	 * @param autoHide Whether or not the toast message should auto hide
	 */
	public showSavedMessage(message?: string, autoHide: boolean = true): void {
		void this.toastController
			.create({
				message: message || translate('MESSAGES.SAVED'),
				...(autoHide ? { duration: 2000 } : {}),
				...(autoHide
					? {}
					: {
							buttons: [
								{
									text: 'Ok',
									handler: () => {},
								},
							],
						}),
				cssClass: '_saved-toast',
				position: this.validationService.isOnMobile() ? 'top' : 'bottom',
			})
			.then((toast) => {
				void toast.present().catch();
			})
			.catch();
	}
}
